<template>
    <UiGeneralText id="UiGeneralText" :blok="blok" class="apr-general-text" />
</template>

<script setup>
defineProps({ blok: Object });
</script>

<style scoped lang="postcss">
.apr-general-text.generalText {
    :deep(h1),
    :deep(h2) {
        @apply text-xl md:text-4xl leading-normal;
    }

    :deep(h3) {
        @apply text-xl md:text-3xl leading-normal;
    }

    :deep(h4) {
        @apply text-lg md:text-2xl leading-normal;
    }

    :deep(h5) {
        @apply text-base md:text-xl leading-normal;
    }

    :deep(h6) {
        @apply text-sm md:text-lg leading-normal;
    }
}
</style>
